import { createFileRoute } from '@tanstack/react-router'
import { CustomerLocationsMap } from '../components/customer-locations-map/CustomerLocationsMap'

export const Route = createFileRoute('/_a/customerLocationsMap')({
  component: CustomerLocationsMap,
})
